import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from "axios";
import Modal from "react-modal";
import "./ProjectOverviewListingRecenInvoices.css";
import { toast } from "react-toastify";
import crssrImage from "../../../../images/singleinvoice/cross-red.svg";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { createDateConvert, dateConvert } from "../../../../helpers/dateHelper";
import NewSprintModal from '../../helpers/NewSprintModal';
import { useSelector } from "react-redux";
import moment from "moment";
import SprintViewModal from "./modals/SprintViewModal";
import StatusModal from "./modals/StatusModal";
import { useDispatch } from 'react-redux';
import { setSprintView, setSprintData, setSprintStatusView } from "../../../../features/projects/projectSlice";
import { BudgetedSprintHours, SprintCost, TrackedSprintHours } from '../../../../helpers/ProjectHelpers';
import { useGetProjectThreshold } from '../../../../features/projects/useProjects';
import { logout, reset } from "../../../../features/auth/authSlice.js";
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";

const SprintTable = (props) => {
    const [sprintModalOpen, setSprintModalOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settings = JSON.parse(localStorage.getItem("settings"));
    const { forex } = useSelector((state) => state.forex);
    const projectLoading = props.isLoadingProject;
    const preferredCurrency = props.project?.client_name?.preferred_currency || 'USD';
    const [timeThresholdData, setTimeThresholdData] = useState({});
    const [loadingRowIndex, setLoadingRowIndex] = useState(-1);
    const [budgetThresholdData, setBudgetThresholdData] = useState({});
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const user = useSelector((state) => state.auth.user);
    let token = null;
    if (user) {
        if (user && user.token) {
            token = user.token;
        }
    }

    const convertCreatedDate = (rowData) => {
        const timestamp = rowData.created_at;
        const formattedDate = moment(timestamp).format('MMMM DD, YYYY');
        return formattedDate;
    }

    const ConvertDeliveryDate = (rowData) => {
        if (rowData.delivered_date && rowData.sprint_status === "Delivered") {
            const timestamp = rowData.delivered_date;
            return moment(timestamp).format('MMMM DD, YYYY');
        } else if (rowData.sprint_status === "In Progress") {
            return "In Progress";
        }
        else if (rowData.sprint_status === "Cancelled") {
            return "N/A";
        } else {
            return rowData.sprint_status;
        }
    };

    const ConvertStatus = (rowData) => {
        const isClickable = props.project?.is_archived === false;

        const getStatusElement = (status, className) => (
            <span
                className={className}
                style={{ cursor: isClickable ? "pointer" : "default", opacity: isClickable ? 1 : 0.6 }}
                onClick={isClickable ? () => handleOpenStatusModal(rowData) : undefined}
            >
                {status}
            </span>
        );

        if (rowData.delivered_date && rowData.sprint_status === "Delivered") {
            return getStatusElement("Delivered", "delivered");
        } else if (rowData.sprint_status === "In Progress") {
            return getStatusElement("In Progress", "in-progress");
        } else if (rowData.sprint_status === "Cancelled") {
            return getStatusElement("Cancelled", "cancelled");
        } else {
            return getStatusElement("Scheduled", "scheduled");
        }
    }

    function detailCTA(rowData) {
        return (
            <div className="detail-button">
                <button
                    className="cta-button"
                    onClick={() => handleDetailClick(rowData)}
                    disabled={props.project?.is_archived || loadingRowIndex === rowData._id}
                    style={{
                        cursor: (props.project?.is_archived || loadingRowIndex === rowData._id) ? "not-allowed" : "pointer",
                        opacity: props.project?.is_archived ? 0.5 : 1,
                    }}
                >
                    {loadingRowIndex === rowData._id ? (
                        <div
                            style={{
                                width: "60px",
                                height: "18px",
                                borderRadius: "4px",
                                backgroundColor: "rgba(255, 255, 255, 0.3)",
                                animation: "pulse 1.5s ease-in-out infinite",
                            }}
                        />
                    ) : (
                        "Details"
                    )}
                </button>
            </div>
        );
    }

    function hubspotMapCTA(rowData) {
        const mapping = sprintMappings[rowData._id];
        if (mapping) {
            return (
                <div className="detail-button" style={{ display: "inline-flex", alignItems: "center", gap: "6px", maxWidth: "100%" }}>
                    <button
                        className="cta-button"
                        type="button"
                        onClick={() => openHsMapModal(rowData)}
                        title={mapping.hubspot_task_subject || "HubSpot Mapped"}
                        style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "5px", whiteSpace: "nowrap" }}
                    >
                        <HubSpotLogo size={10} /> Mapped
                    </button>
                    <button
                        className="cta-button"
                        type="button"
                        onClick={() => handleHsUnmap(rowData._id)}
                        style={{ minWidth: "34px", padding: "0 10px" }}
                        title="Remove HubSpot mapping"
                    >
                        ✕
                    </button>
                </div>
            );
        }
        return (
            <div className="detail-button">
                <button
                    className="cta-button"
                    type="button"
                    onClick={() => openHsMapModal(rowData)}
                    style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "5px", whiteSpace: "nowrap" }}
                >
                    <HubSpotLogo size={10} /> Map
                </button>
            </div>
        );
    }

    // const handleDetailClick = async (rowData) => {
    //     setSprintModalOpen(true);
    //     setLoadingRowIndex(rowData._id); // Show loading indicator for this row

    //     try {
    //         // Fetch Time and Budget thresholds in parallel
    //         const [timeResponse, budgetResponse] = await Promise.all([
    //             axios.post(
    //                 "/api/get/project/thresholds",
    //                 { projectId: rowData._id, thresholdType: "time" },
    //                 { headers: { Authorization: `Bearer ${token}` } }
    //             ),
    //             axios.post(
    //                 "/api/get/project/thresholds",
    //                 { projectId: rowData._id, thresholdType: "budget" },
    //                 { headers: { Authorization: `Bearer ${token}` } }
    //             ),
    //         ]);

    //         // Store threshold data
    //         const newTimeThresholdData = timeResponse.data;
    //         const newBudgetThresholdData = budgetResponse.data;

    //         setTimeThresholdData(newTimeThresholdData);
    //         setBudgetThresholdData(newBudgetThresholdData);

    //         // Prepare sprint data
    //         const sprintData = {
    //             ...rowData,
    //             project_name: props.project?.project_name,
    //             timeThresholdData: newTimeThresholdData?.data,
    //             budgetThresholdData: newBudgetThresholdData?.data,
    //             clientId: props.project?.client_name?._id
    //         };

    //         // Dispatch actions
    //         await dispatch(setSprintData(sprintData));
    //         await dispatch(setSprintView(true));
    //     } catch (error) {
    //         console.error("Error fetching thresholds:", error);

    //         if (error.response?.data?.status === "deleted") {
    //             handleDeletedUser();
    //         } else {
    //             toast.error("Something went wrong. Please try again.", { position: "bottom-right", autoClose: 2000 });
    //         }
    //     } finally {
    //         setLoadingRowIndex(-1); // Remove loading indicator
    //     }
    // };

    const handleDetailClick = async (rowData) => {
    if (!rowData?._id) {
        toast.error("Invalid project ID", { position: "bottom-right", autoClose: 2000 });
        return;
    }

    if (!token) {
        toast.error("Authorization token missing", { position: "bottom-right", autoClose: 2000 });
        return;
    }

    setSprintModalOpen(true);
    setLoadingRowIndex(rowData._id);

    try {
        const payload = { projectId: rowData._id };
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const [timeResponse, budgetResponse] = await Promise.all([
            axios.post("/api/get/project/thresholds", { ...payload, thresholdType: "time" }, config),
            axios.post("/api/get/project/thresholds", { ...payload, thresholdType: "budget" }, config),
        ]);

        const newTimeThresholdData = timeResponse.data;
        const newBudgetThresholdData = budgetResponse.data;

        setTimeThresholdData(newTimeThresholdData);
        setBudgetThresholdData(newBudgetThresholdData);

        const sprintData = {
            ...rowData,
            project_name: props.project?.project_name,
            timeThresholdData: newTimeThresholdData?.data,
            budgetThresholdData: newBudgetThresholdData?.data,
            clientId: props.project?.client_name?._id
        };

        await dispatch(setSprintData(sprintData));
        await dispatch(setSprintView(true));
    } catch (error) {
        console.error("Error fetching thresholds:", error);

        if (error.response?.data?.status === "deleted") {
            handleDeletedUser();
        } else {
            toast.error("Something went wrong. Please try again.", { position: "bottom-right", autoClose: 2000 });
        }
    } finally {
        setLoadingRowIndex(-1);
    }
};

    // Handle user deletion scenario
    const handleDeletedUser = () => {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());

        toast.error("This user is deleted!", {
            position: "bottom-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });

        navigate("/");
    };


    // const TrackedHours = (rowData) => {
    //     console.log('track', rowData._id);
    // }

    function ConvertHelper(currencyFrom, currencyTo, amount, forex) {
        const currencyFromRate = forex[currencyFrom];
        const currencyToRate = forex[currencyTo];
        const amountConvertedUSD = amount / currencyFromRate;
        const amountConvertTo = amountConvertedUSD * currencyToRate;
        return amountConvertTo;
    }

    // ── HubSpot sprint sync state ────────────────────────────────────────────
    const [hsConnected, setHsConnected] = useState(false);
    const [hsTaskSyncEnabled, setHsTaskSyncEnabled] = useState(false);
    const [hsProjectId, setHsProjectId] = useState(null); // resolved HubSpot project ID

    // Sync modal (list of HubSpot tasks)
    const [hsSyncOpen, setHsSyncOpen] = useState(false);
    const [hsTasks, setHsTasks] = useState([]);
    const [hsTasksLoading, setHsTasksLoading] = useState(false);

    // Sprint mappings (which sprints are already mapped to HS tasks)
    const [sprintMappings, setSprintMappings] = useState({}); // sprintId → { hubspot_task_id, hubspot_task_subject }

    // Push modal (HS task → new sprint)
    const [hsPushTask, setHsPushTask] = useState(null);
    const [hsPushOpen, setHsPushOpen] = useState(false);
    const [hsPushForm, setHsPushForm] = useState({ sprint_name: "", start_date: "", end_date: "", budget: "", totalHours: "" });
    const [hsPushEditMode, setHsPushEditMode] = useState(false);
    const [hsPushConfirmed, setHsPushConfirmed] = useState(false);
    const [hsPushing, setHsPushing] = useState(false);

    // Map modal (existing sprint → HS task)
    const [hsMapSprint, setHsMapSprint] = useState(null); // sprint being mapped
    const [hsMapOpen, setHsMapOpen] = useState(false);
    const [hsMapTasks, setHsMapTasks] = useState([]); // unmapped tasks only
    const [hsMapTasksLoading, setHsMapTasksLoading] = useState(false);
    const [hsMapSelectedTask, setHsMapSelectedTask] = useState(null);
    const [hsMapping, setHsMapping] = useState(false);

    // Fetch HubSpot config + resolve HS project ID on mount
    useEffect(() => {
        if (!token || !props.project?._id) return;
        const headers = { Authorization: `Bearer ${token}` };
        axios.get("/api/integrations/hubspot/config", { headers }).then(r => {
            if (r.data?.connected) {
                setHsConnected(true);
                setHsTaskSyncEnabled(!!r.data?.sync_task_enabled);
                // Resolve HubSpot project ID from mapping tables
                axios.get(`/api/integrations/hubspot/talenton-project/${props.project._id}/tasks`, { headers })
                    .then(r2 => {
                        if (r2.data?.hubspot_project_id) setHsProjectId(r2.data.hubspot_project_id);
                    })
                    .catch(() => {});
            }
        }).catch(() => {});
    }, [token, props.project?._id]);

    // Fetch sprint-task mappings whenever sprints change
    const fetchSprintMappings = useCallback(() => {
        if (!token || !props.project?._id) return;
        axios.get(`/api/integrations/hubspot/sprint-task-map?projectId=${props.project._id}`, {
            headers: { Authorization: `Bearer ${token}` },
        }).then(r => {
            const map = {};
            (r.data?.mappings || []).forEach(m => {
                map[m.talenton_sprint_id] = { hubspot_task_id: m.hubspot_task_id, hubspot_task_subject: m.hubspot_task_subject };
            });
            setSprintMappings(map);
        }).catch(() => {});
    }, [token, props.project?._id]);

    useEffect(() => { fetchSprintMappings(); }, [fetchSprintMappings]);

    // Open sync modal
    const openHsSyncModal = useCallback(async () => {
        setHsSyncOpen(true);
        setHsTasksLoading(true);
        try {
            const r = await axios.get(
                `/api/integrations/hubspot/talenton-project/${props.project._id}/tasks`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (r.data?.hubspot_project_id) setHsProjectId(r.data.hubspot_project_id);
            setHsTasks(r.data?.tasks || []);
        } catch {
            toast.error("Failed to load HubSpot tasks.", { position: "bottom-right", autoClose: 2000 });
        } finally {
            setHsTasksLoading(false);
        }
    }, [token, props.project?._id]);

    // Open push modal for a HS task
    const openHsPushModal = (task) => {
        setHsPushTask(task);
        setHsPushEditMode(false);
        setHsPushConfirmed(false);
        setHsPushForm({
            sprint_name: task.subject || "",
            start_date: "",
            end_date: task.due_date || "",
            budget: "",
            totalHours: "",
        });
        setHsPushOpen(true);
    };

    const handleHsPush = async () => {
        setHsPushing(true);
        try {
            const r = await axios.post(
                `/api/integrations/hubspot/tasks/${hsPushTask.id}/push-sprint`,
                {
                    talentonProjectId: props.project._id,
                    sprint_name: hsPushForm.sprint_name,
                    start_date: hsPushForm.start_date || null,
                    end_date: hsPushForm.end_date || null,
                    budget: hsPushForm.budget || 0,
                    totalHours: hsPushForm.totalHours || 0,
                    hubspot_task_subject: hsPushTask.subject,
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (r.data.status === "already_synced") {
                toast.info("This task is already mapped to a sprint.", { position: "bottom-right", autoClose: 3000 });
            } else {
                toast.success(`Sprint "${hsPushForm.sprint_name}" created!`, { position: "bottom-right", autoClose: 3000 });
                setHsTasks(prev => prev.map(t => t.id === hsPushTask.id
                    ? { ...t, synced: true, talenton_sprint_name: hsPushForm.sprint_name }
                    : t
                ));
                fetchSprintMappings();
                if (props.refetchProject) props.refetchProject();
            }
            setHsPushOpen(false);
        } catch (err) {
            toast.error(err?.response?.data?.message || "Failed to push sprint.", { position: "bottom-right", autoClose: 3000 });
        } finally {
            setHsPushing(false);
        }
    };

    // Open map modal for an existing sprint
    const openHsMapModal = async (sprint) => {
        setHsMapSprint(sprint);
        setHsMapSelectedTask(null);
        setHsMapOpen(true);
        setHsMapTasksLoading(true);
        try {
            const r = await axios.get(
                `/api/integrations/hubspot/talenton-project/${props.project._id}/tasks`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setHsMapTasks(r.data?.tasks || []);
        } catch {
            toast.error("Failed to load HubSpot tasks.", { position: "bottom-right", autoClose: 2000 });
        } finally {
            setHsMapTasksLoading(false);
        }
    };

    const handleHsMap = async () => {
        if (!hsMapSelectedTask) return;
        setHsMapping(true);
        try {
            await axios.post(
                `/api/integrations/hubspot/sprint-task-map`,
                {
                    sprintId: hsMapSprint._id,
                    hubspotTaskId: hsMapSelectedTask.id,
                    hubspotTaskSubject: hsMapSelectedTask.subject,
                    talentonProjectId: props.project._id,
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success("Sprint mapped to HubSpot task!", { position: "bottom-right", autoClose: 3000 });
            setHsMapOpen(false);
            fetchSprintMappings();
        } catch (err) {
            toast.error(err?.response?.data?.message || "Failed to map sprint.", { position: "bottom-right", autoClose: 3000 });
        } finally {
            setHsMapping(false);
        }
    };

    const handleHsUnmap = async (sprintId) => {
        try {
            await axios.delete(`/api/integrations/hubspot/sprint-task-map/${sprintId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success("HubSpot mapping removed.", { position: "bottom-right", autoClose: 2000 });
            fetchSprintMappings();
        } catch {
            toast.error("Failed to remove mapping.", { position: "bottom-right", autoClose: 2000 });
        }
    };

    const showHsSync = hsConnected && hsTaskSyncEnabled && hsProjectId;

    const hsModalStyle = (width = "34%") => ({
        content: {
            width,
            position: "fixed",
            top: "50%",
            left: "50%",
            parent: document.querySelector(".admin-outer.time.tracker"),
        },
    });

    // HubSpot logo SVG
    const HubSpotLogo = ({ size = 16 }) => (
        <svg width={size} height={size} viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
            <path d="M426.6 241.3c-18.7-26.5-45.7-43.2-76.2-48.1v-54.7c13.5-5.8 22.9-19.2 22.9-34.8V92.3C373.3 69 354.3 50 331 50h-11.4c-23.3 0-42.3 19-42.3 42.3v11.4c0 15.6 9.4 29 22.9 34.8v54.7c-22.4 3.4-43.5 12.8-61.5 27.7L117.2 141c1-3.7 1.6-7.6 1.6-11.6 0-25.3-20.5-45.8-45.8-45.8S27.2 104.1 27.2 129.4s20.5 45.8 45.8 45.8c10.6 0 20.4-3.6 28.1-9.6l119.1 78.3c-11.2 20.4-17.4 43.7-17.4 67.8 0 28.3 8.4 55.2 23.9 78l-36.2 36.2c-2.8-.9-5.7-1.4-8.8-1.4-16.5 0-29.9 13.4-29.9 29.9S165.2 484 181.7 484s29.9-13.4 29.9-29.9c0-3.1-.5-6.1-1.4-8.8l35.8-35.8c23.3 16.3 51.1 25.5 80.6 25.5 78.7 0 142.6-63.9 142.6-142.6 0-21.2-4.7-41.7-13.4-60.1l-8.2 8.6-.9-1.6zM325.6 392.5c-55.8 0-101.1-45.3-101.1-101.1s45.3-101.1 101.1-101.1 101.1 45.3 101.1 101.1-45.3 101.1-101.1 101.1z" fill="#ff7a59"/>
        </svg>
    );

    const [statusOpen, setStatusOpen] = useState(false);
    const [statusModalData, setStatusModalData] = useState(null);
    const handleOpenStatusModal = async (data) => {

        await dispatch(setSprintData(data));
        await dispatch(setSprintStatusView(true));
        //     setStatusOpen(!statusOpen);
        //    await setStatusModalData(data);

    };


    return (
        <>
            <style>{`
                @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }

                .hs-sync-btn {
                  display: flex; align-items: center; gap: 6px;
                  background: none; border: 1.5px solid #e8e8e8;
                  border-radius: 8px; padding: 5px 12px;
                  font-size: 13px; font-weight: 500; color: #454F59;
                  cursor: pointer; transition: all 0.18s; line-height: 1.4;
                }
                .hs-sync-btn:hover { border-color: #ff7a59; color: #ff7a59; background: #fff5f2; }

                .hs-project-scroll { max-height: 50vh; overflow-y: auto; }
                .hs-project-scroll::-webkit-scrollbar { width: 4px; }
                .hs-project-scroll::-webkit-scrollbar-track { background: transparent; }
                .hs-project-scroll::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 4px; }

                .hs-project-list { display: flex; flex-direction: column; gap: 10px; }
                .hs-project-item {
                  display: flex; align-items: center; justify-content: space-between;
                  gap: 12px; padding: 14px 16px; border-radius: 10px;
                  border: 1px solid #eef0f2; background: #fff;
                  transition: border-color 0.15s, box-shadow 0.15s;
                }
                .hs-project-item:hover { border-color: #d6dbff; box-shadow: 0 2px 8px rgba(100,121,248,0.07); }
                .hs-project-item-info { flex: 1; min-width: 0; }
                .hs-project-item-name {
                  font-size: 14px; font-weight: 600; color: #282828;
                  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 1.4;
                }
                .hs-project-item-meta { font-size: 12px; color: #9ca3af; margin-top: 3px; line-height: 1.4; }
                .hs-project-item-synced-name {
                  font-size: 12px; color: #16a34a; margin-top: 2px;
                  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                }
                .hs-project-item-action { flex-shrink: 0; display: flex; justify-content: flex-end; }

                .hs-synced-badge {
                  display: inline-flex; align-items: center; gap: 4px;
                  font-size: 12px; font-weight: 600; color: #16a34a;
                  background: #dcfce7; border: 1px solid #bbf7d0;
                  border-radius: 20px; padding: 4px 11px; white-space: nowrap;
                }
                .hs-push-btn {
                  background: #6479F8; color: #fff; border: none; border-radius: 6px;
                  padding: 5px 10px; font-size: 11px; font-weight: 600;
                  cursor: pointer; white-space: nowrap; transition: background 0.15s; letter-spacing: 0.2px;
                }
                .hs-push-btn:hover { background: #4f63d4; }

                .hs-form-label { font-size: 13px; font-weight: 600; color: #454F59; margin-bottom: 5px; display: block; }
                .hs-form-input {
                  width: 100%; padding: 8px 12px; border: 1px solid #e0e0e0; border-radius: 8px;
                  font-size: 14px; color: #282828; box-sizing: border-box; outline: none; transition: border-color 0.15s;
                }
                .hs-form-input:focus { border-color: #6479F8; }
                .hs-form-row { margin-bottom: 14px; }
                .hs-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
                .hs-confirm-row {
                  display: flex; align-items: flex-start; gap: 10px; margin: 18px 0 0;
                  padding: 14px; background: #f7f8ff; border-radius: 8px; border: 1px solid #e0e5ff;
                }
                .hs-confirm-row input[type=checkbox] { margin-top: 2px; width: 16px; height: 16px; cursor: pointer; flex-shrink: 0; accent-color: #6479F8; }
                .hs-confirm-row label { font-size: 13px; color: #454F59; cursor: pointer; line-height: 1.5; }
                .hs-detail-card {
                  background: #f7f8ff; border-radius: 10px; padding: 14px 16px;
                  margin-bottom: 16px; display: flex; gap: 12px; align-items: center;
                  border: 1px solid #e0e5ff;
                }
                .hs-detail-avatar {
                  width: 40px; height: 40px; border-radius: 50%; background: #6479F8;
                  color: #fff; display: flex; align-items: center; justify-content: center;
                  font-size: 18px; font-weight: 700; flex-shrink: 0;
                }
                .hs-detail-rows { border-radius: 10px; border: 1px solid #ebebeb; overflow: hidden; }
                .hs-detail-row { display: flex; padding: 9px 14px; font-size: 13px; border-bottom: 1px solid #f3f4f6; }
                .hs-detail-row:last-child { border-bottom: none; }
                .hs-detail-row:nth-child(even) { background: #fafbff; }
                .hs-detail-row-label { color: #9ca3af; width: 110px; flex-shrink: 0; font-weight: 500; }
                .hs-detail-row-value { color: #282828; font-weight: 500; }
                .hs-modal-actions { display: flex; gap: 10px; justify-content: flex-end; margin-top: 20px; }
                .hs-cancel-btn {
                  background: none; border: 1.5px solid #e0e0e0; border-radius: 8px;
                  padding: 8px 18px; font-size: 14px; color: #454F59; cursor: pointer; transition: border-color 0.15s;
                }
                .hs-cancel-btn:hover { border-color: #aaa; }
                .hs-submit-btn {
                  background: #6479F8; color: #fff; border: none; border-radius: 8px;
                  padding: 8px 22px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background 0.15s;
                }
                .hs-submit-btn:hover:not(:disabled) { background: #4f63d4; }
                .hs-submit-btn:disabled { opacity: 0.55; cursor: not-allowed; }
                .hs-empty { text-align: center; color: #c0c4cc; padding: 36px 0; font-size: 14px; }
                .hs-loading { text-align: center; color: #c0c4cc; padding: 36px 0; font-size: 14px; }
                .hs-missing-notice {
                  font-size: 12px; color: #e57373; background: #fff5f5; border: 1px solid #fecaca;
                  border-radius: 7px; padding: 8px 12px; margin-bottom: 14px;
                }
                .hs-map-task-item {
                  display: flex; align-items: center; gap: 10px;
                  padding: 10px 14px; margin-bottom: 6px; border-radius: 8px; cursor: pointer;
                  border: 1.5px solid #eef0f2; background: #fff; transition: border-color 0.15s;
                }
                .hs-map-task-item.selected { border-color: #6479F8; background: #f0f3ff; }
                .hs-map-task-item:hover { border-color: #d6dbff; }
            `}</style>
            <div className="table-head-outer">
                <div className="table-head">
                    Sprints
                </div>
                {(projectLoading) ? (
                    <div
                        style={{
                            width: "120px",
                            height: "44px",
                            borderRadius: "6px",
                            backgroundColor: "#e5e7eb",
                            animation: "pulse 1.5s ease-in-out infinite",
                        }}
                    />
                ) : (
                    props.project.is_archived === false && (
                        <div className="button-sec-invoice" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                            {showHsSync && (
                                <a
                                    className="hs-sync-btn"
                                    href="#"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        openHsSyncModal();
                                    }}
                                >
                                    <HubSpotLogo size={15} />
                                    Sync from HubSpot
                                </a>
                            )}
                            <NewSprintModal proId={props.project?._id} project={props.project} preferredCurrency={preferredCurrency} />
                        </div>
                    )
                )}
            </div>
            <div className="listing-recent-invoice-inner sprint-client-outer-section">
                {projectLoading ? (
                    <DataTable
                        value={Array.from({ length: 5 })}
                        removableSort
                        tableStyle={{ minWidth: "50rem", width: "100%", textAlign: "left" }}
                        paginator={false}
                        rows={5}
                    >
                        <Column
                            header="Sprint"
                            sortable
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div
                                    style={{
                                        width: "120px",
                                        height: "22px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}
                        />
                        <Column
                            header={`Budget (${preferredCurrency})`}
                            sortable
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div
                                    style={{
                                        width: "100px",
                                        height: "22px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}
                        />
                        <Column
                            header="Budgeted Hours"
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div
                                    style={{
                                        width: "80px",
                                        height: "22px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}
                        />
                        <Column
                            header="Tracked Hours"
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div
                                    style={{
                                        width: "80px",
                                        height: "22px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}
                        />
                        <Column
                            header="Cost"
                            sortable
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div
                                    style={{
                                        width: "100px",
                                        height: "22px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}
                        />
                        <Column
                            header="Date Created"
                            sortable
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div
                                    style={{
                                        width: "140px",
                                        height: "22px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}
                        />
                        <Column
                            header="Date Delivered"
                            sortable
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div
                                    style={{
                                        width: "140px",
                                        height: "22px",
                                        borderRadius: "4px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}
                        />
                        <Column
                            header="Status"
                            sortable
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div
                                    style={{
                                        width: "90px",
                                        height: "24px",
                                        borderRadius: "999px",
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                    }}
                                />
                            )}
                        />
                        <Column
                            field="_id"
                            style={{ paddingRight: "20px" }}
                            body={() => (
                                <div className="detail-button">
                                    <div
                                        style={{
                                            width: "76px",
                                            height: "31px",
                                            borderRadius: "8px",
                                            backgroundColor: "#e5e7eb",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                        }}
                                    />
                                </div>
                            )}
                        />
                    </DataTable>
                ) : (
                    <DataTable
                        value={props.project.sprints}
                        removableSort
                        tableStyle={{ width: "100%", textAlign: "left", tableLayout: "fixed" }}
                        paginator={false}
                        paginatorClassName="recent-invoices-pagination"
                        rows={5}
                        emptyMessage="No sprints found"
                    >
                        <Column
                            field="sprint_name"
                            header="Sprint"
                            sortable
                            style={{ width: showHsSync ? "16%" : "20%", paddingRight: "12px" }}
                            body={(rowData) => (
                                <span
                                    title={rowData.sprint_name}
                                    style={{
                                        display: "block",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        maxWidth: "100%",
                                    }}
                                >
                                    {rowData.sprint_name}
                                </span>
                            )}
                        ></Column>
                        <Column
                            field="budget"
                            header={`Budget (${preferredCurrency})`}
                            body={(rowData) => {
                                const { budget } = rowData;
                                if (preferredCurrency) {
                                    return new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: props.clientCurrency ? props.clientCurrency : "USD",
                                    }).format(ConvertHelper(preferredCurrency, props.clientCurrency ? props.clientCurrency : "USD", budget, forex));
                                } else {
                                    return new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: props.clientCurrency ? props.clientCurrency : "USD",
                                    }).format(ConvertHelper("USD", props.clientCurrency ? props.clientCurrency : "USD", budget, forex));
                                }
                            }}
                            sortable
                            style={{ width: "10%", paddingRight: "12px" }}
                        ></Column>
                        <Column
                            field="totalHours"
                            header="Budgeted Hrs"
                            body={BudgetedSprintHours}
                            style={{ width: "9%", paddingRight: "12px" }}
                        ></Column>
                        <Column
                            field="project.total_hours"
                            header="Tracked Hrs"
                            body={TrackedSprintHours}
                            style={{ width: "9%", paddingRight: "12px" }}
                        ></Column>
                        <Column
                            field="cost"
                            header="Cost"
                            body={(rowData) => SprintCost(rowData, preferredCurrency || 'USD')}
                            sortable
                            style={{ width: "8%", paddingRight: "12px" }}
                        ></Column>
                        <Column
                            field="project.created_at"
                            body={convertCreatedDate}
                            header="Date Created"
                            sortable
                            style={{ width: "11%", paddingRight: "12px" }}
                        ></Column>
                        <Column
                            field="delivered_date"
                            body={ConvertDeliveryDate}
                            header="Date Delivered"
                            sortable
                            style={{ width: "11%", paddingRight: "12px" }}
                        ></Column>
                        <Column
                            field="sprint_status"
                            header="Status"
                            body={ConvertStatus}
                            sortable
                            style={{ width: "9%", paddingRight: "12px" }}
                        ></Column>
                        <Column
                            field="_id"
                            body={detailCTA}
                            style={{ width: "7%", paddingRight: "8px" }}
                        ></Column>
                        {showHsSync && (
                            <Column
                                header=""
                                style={{ width: "10%", paddingRight: "8px" }}
                                body={hubspotMapCTA}
                            ></Column>
                        )}
                    </DataTable>
                )}
            </div>

            {/* ── HubSpot Sync Modal ──────────────────────────────────────────── */}
            <Modal
                className="client-modal"
                isOpen={hsSyncOpen}
                onRequestClose={() => setHsSyncOpen(false)}
                contentLabel="HubSpot Tasks"
                style={hsModalStyle("480px")}
            >
                <div className="modal">
                    <div className="modal-close-invite outter-modal-main">
                        <a onClick={() => setHsSyncOpen(false)} style={{ cursor: "pointer" }}>
                            <img src={crssrImage} alt="Close" />
                        </a>
                    </div>
                    <div className="modal-client-head">
                        <h2 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <HubSpotLogo size={20} />
                            HubSpot Tasks
                        </h2>
                    </div>
                    <div className="form-field-client-outer">
                        <div className="hs-project-scroll">
                            {hsTasksLoading ? (
                                <div className="hs-loading">Loading tasks from HubSpot…</div>
                            ) : hsTasks.length === 0 ? (
                                <div className="hs-empty">No tasks found under this HubSpot project.</div>
                            ) : (
                                <div className="hs-project-list">
                                    {hsTasks.map(task => (
                                        <div key={task.id} className="hs-project-item" title={task.subject || ""}>
                                            <div className="hs-project-item-info">
                                                <div className="hs-project-item-name">
                                                    {task.subject || <em style={{ color: "#c0c4cc", fontWeight: 400 }}>Unnamed task</em>}
                                                </div>
                                                <div className="hs-project-item-meta">
                                                    {task.due_date ? `Due: ${task.due_date}` : "No due date"}
                                                </div>
                                                {task.synced && task.talenton_sprint_name && (
                                                    <div className="hs-project-item-synced-name" title={task.talenton_sprint_name}>
                                                        ✓ {task.talenton_sprint_name}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="hs-project-item-action">
                                                {task.synced ? (
                                                    <span className="hs-synced-badge">✓ Synced</span>
                                                ) : (
                                                    <button className="hs-push-btn" onClick={() => { setHsSyncOpen(false); openHsPushModal(task); }}>
                                                        Push to Talenton
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>

            {/* ── HubSpot Push Modal ──────────────────────────────────────────── */}
            <Modal
                className="client-modal"
                isOpen={hsPushOpen}
                onRequestClose={() => setHsPushOpen(false)}
                contentLabel="Push to Talenton"
                style={hsModalStyle("34%")}
            >
                <div className="modal">
                    <div className="modal-close-invite outter-modal-main">
                        <a onClick={() => setHsPushOpen(false)} style={{ cursor: "pointer" }}>
                            <img src={crssrImage} alt="Close" />
                        </a>
                    </div>
                    <div className="modal-client-head">
                        <h2 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <HubSpotLogo size={20} />
                            Push to Talenton
                        </h2>
                    </div>
                    <div className="form-field-client-outer">
                        {/* Task source card */}
                        <div className="hs-detail-card">
                            <div className="hs-detail-avatar">
                                {(hsPushTask?.subject || "?")[0]?.toUpperCase()}
                            </div>
                            <div style={{ minWidth: 0 }}>
                                <div style={{ fontWeight: 700, fontSize: 14, color: "#282828", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {hsPushTask?.subject || "Unnamed task"}
                                </div>
                                <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>HubSpot Task ID: {hsPushTask?.id}</div>
                            </div>
                        </div>

                        {hsPushEditMode ? (
                            <>
                                <div className="hs-form-row">
                                    <label className="hs-form-label">Sprint Name <span style={{ color: "#e57373" }}>*</span></label>
                                    <input
                                        className="hs-form-input"
                                        value={hsPushForm.sprint_name}
                                        onChange={e => setHsPushForm(f => ({ ...f, sprint_name: e.target.value }))}
                                        placeholder="Enter sprint name"
                                        autoFocus
                                    />
                                </div>
                                <div className="hs-form-grid">
                                    <div className="hs-form-row">
                                        <label className="hs-form-label">Start Date</label>
                                        <input className="hs-form-input" type="date" value={hsPushForm.start_date} onChange={e => setHsPushForm(f => ({ ...f, start_date: e.target.value }))} />
                                    </div>
                                    <div className="hs-form-row">
                                        <label className="hs-form-label">End Date</label>
                                        <input className="hs-form-input" type="date" value={hsPushForm.end_date} onChange={e => setHsPushForm(f => ({ ...f, end_date: e.target.value }))} />
                                    </div>
                                </div>
                                <div className="hs-form-grid">
                                    <div className="hs-form-row">
                                        <label className="hs-form-label">Budget</label>
                                        <input className="hs-form-input" type="number" min="0" value={hsPushForm.budget} onChange={e => setHsPushForm(f => ({ ...f, budget: e.target.value }))} placeholder="0" />
                                    </div>
                                    <div className="hs-form-row">
                                        <label className="hs-form-label">Total Hours</label>
                                        <input className="hs-form-input" type="number" min="0" value={hsPushForm.totalHours} onChange={e => setHsPushForm(f => ({ ...f, totalHours: e.target.value }))} placeholder="0" />
                                    </div>
                                </div>
                                <div className="hs-confirm-row">
                                    <input type="checkbox" id="hs-push-confirm" checked={hsPushConfirmed} onChange={e => setHsPushConfirmed(e.target.checked)} />
                                    <label htmlFor="hs-push-confirm">
                                        I confirm this sprint should be created in Talenton and linked to this HubSpot task.
                                    </label>
                                </div>
                            </>
                        ) : (
                            <>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                                    <span style={{ fontSize: "12px", color: "#9ca3af", fontWeight: 500 }}>Sprint details</span>
                                    <button
                                        onClick={() => { setHsPushEditMode(true); setHsPushConfirmed(false); }}
                                        style={{
                                            background: "none", border: "1px solid #e0e0e0", borderRadius: "6px",
                                            padding: "3px 10px", fontSize: "12px", color: "#6479F8",
                                            cursor: "pointer", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px",
                                        }}
                                    >
                                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                        </svg>
                                        Edit
                                    </button>
                                </div>
                                <div className="hs-detail-rows">
                                    {[
                                        { label: "Sprint Name", value: hsPushForm.sprint_name },
                                        { label: "End Date", value: hsPushForm.end_date || "—" },
                                        { label: "Budget", value: hsPushForm.budget ? `$${hsPushForm.budget}` : "—" },
                                        { label: "Total Hours", value: hsPushForm.totalHours || "—" },
                                    ].map(row => (
                                        <div key={row.label} className="hs-detail-row">
                                            <span className="hs-detail-row-label">{row.label}</span>
                                            <span className="hs-detail-row-value" style={{ color: row.value === "—" ? "#c0c4cc" : "#282828" }}>{row.value}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="hs-confirm-row">
                                    <input type="checkbox" id="hs-push-confirm" checked={hsPushConfirmed} onChange={e => setHsPushConfirmed(e.target.checked)} />
                                    <label htmlFor="hs-push-confirm">
                                        I confirm this sprint should be created in Talenton and linked to this HubSpot task.
                                    </label>
                                </div>
                            </>
                        )}

                        <div className="hs-modal-actions">
                            <button className="hs-cancel-btn" onClick={() => setHsPushOpen(false)}>Cancel</button>
                            <button
                                className="hs-submit-btn"
                                disabled={hsPushing || !hsPushForm.sprint_name?.trim() || !hsPushConfirmed}
                                onClick={handleHsPush}
                            >
                                {hsPushing ? "Pushing…" : "Push to Talenton"}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* ── HubSpot Map Modal ───────────────────────────────────────────── */}
            <Modal
                className="client-modal"
                isOpen={hsMapOpen}
                onRequestClose={() => setHsMapOpen(false)}
                contentLabel="Map Sprint to HubSpot Task"
                style={hsModalStyle("480px")}
            >
                <div className="modal">
                    <div className="modal-close-invite outter-modal-main">
                        <a onClick={() => setHsMapOpen(false)} style={{ cursor: "pointer" }}>
                            <img src={crssrImage} alt="Close" />
                        </a>
                    </div>
                    <div className="modal-client-head">
                        <h2 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <HubSpotLogo size={20} />
                            Map to HubSpot Task
                        </h2>
                    </div>
                    <div className="form-field-client-outer">
                        {hsMapSprint && (
                            <div className="hs-detail-card">
                                <div className="hs-detail-avatar">
                                    {(hsMapSprint.sprint_name || "S")[0]?.toUpperCase()}
                                </div>
                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontWeight: 700, fontSize: 14, color: "#282828", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {hsMapSprint.sprint_name}
                                    </div>
                                    <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>Select a HubSpot task to link</div>
                                </div>
                            </div>
                        )}
                        {hsMapTasksLoading ? (
                            <div className="hs-loading">Loading HubSpot tasks…</div>
                        ) : hsMapTasks.length === 0 ? (
                            <div className="hs-empty">No HubSpot tasks available.</div>
                        ) : (
                            <div className="hs-project-scroll" style={{ marginBottom: "4px" }}>
                                <div className="hs-project-list">
                                    {hsMapTasks.map(task => {
                                        const isMapped = task.synced;
                                        const isSelected = hsMapSelectedTask?.id === task.id;
                                        return (
                                            <div
                                                key={task.id}
                                                className={`hs-map-task-item${isSelected ? " selected" : ""}${isMapped ? " disabled" : ""}`}
                                                onClick={isMapped ? undefined : () => setHsMapSelectedTask(task)}
                                                style={{ opacity: isMapped ? 0.6 : 1, cursor: isMapped ? "not-allowed" : "pointer" }}
                                            >
                                                <input type="radio" readOnly checked={isSelected} disabled={isMapped} style={{ accentColor: "#6479F8", flexShrink: 0 }} />
                                                <div style={{ minWidth: 0, flex: 1 }}>
                                                    <div className="hs-project-item-name">{task.subject || "Untitled"}</div>
                                                    <div className="hs-project-item-meta">{task.due_date ? `Due: ${task.due_date}` : "No due date"}</div>
                                                </div>
                                                {isMapped && (
                                                    <span style={{
                                                        flexShrink: 0, fontSize: "11px", fontWeight: 600,
                                                        color: "#16a34a", background: "#dcfce7",
                                                        border: "1px solid #bbf7d0", borderRadius: "20px",
                                                        padding: "2px 9px", whiteSpace: "nowrap",
                                                    }}>
                                                        Mapped
                                                    </span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                        <div className="hs-modal-actions">
                            <button className="hs-cancel-btn" onClick={() => setHsMapOpen(false)}>Cancel</button>
                            <button
                                className="hs-submit-btn"
                                disabled={hsMapping || !hsMapSelectedTask}
                                onClick={handleHsMap}
                            >
                                {hsMapping ? "Mapping…" : "Confirm Map"}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <SprintViewModal preferredCurrency={preferredCurrency} />
            <StatusModal data={statusModalData} statusOpen={statusOpen} />
        </>
    );
};
export default SprintTable;